import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kurlatopunetaxiservice() {



  const cardData = {


  keyword: "Kurla to Pune Taxi Service",

  headingDescription: "Trustline Cab provides reliable Kurla to Pune taxi services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family vacations, railway station transfers, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure punctual pickups, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey from Kurla to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Kurla to Pune taxi services.",

  topPlaces: [
    {
      title: "Yerwada",
      description: "Yerwada is a prominent commercial and residential locality in Pune known for business establishments, hotels, educational institutions, hospitals, and excellent connectivity to Pune Airport and the city center."
    },
    {
      title: "Kharadi",
      description: "Kharadi is one of Pune's leading IT and business hubs, home to EON IT Park, multinational companies, corporate offices, premium hotels, and modern commercial developments. It is a preferred destination for business travelers."
    },
    {
      title: "Bavdhan",
      description: "Bavdhan is a rapidly developing residential and commercial area offering premium housing projects, educational institutions, office spaces, and quick access to Baner, Chandani Chowk, and the Mumbai-Pune Expressway."
    },
    {
      title: "Chakan MIDC",
      description: "Chakan MIDC is a major industrial corridor housing automobile manufacturers, engineering companies, logistics hubs, and large production facilities. It is a key destination for industrial and corporate travel."
    },
    {
      title: "Amanora Park Town",
      description: "Amanora Park Town is a modern integrated township featuring commercial offices, shopping malls, residential communities, entertainment zones, and lifestyle amenities. It attracts professionals and families throughout the year."
    },
    {
      title: "Tathawade",
      description: "Tathawade is an emerging suburb known for educational institutions, residential developments, commercial spaces, and excellent connectivity to Wakad, Hinjewadi, and Pimpri Chinchwad."
    },
    {
      title: "Raja Dinkar Kelkar Museum",
      description: "Raja Dinkar Kelkar Museum is one of Pune's finest museums, showcasing an extensive collection of traditional Indian art, antiques, sculptures, and historical artifacts. It is a popular destination for culture and history enthusiasts."
    },
    {
      title: "Parvati Hill",
      description: "Parvati Hill is a famous heritage attraction offering ancient temples, panoramic views of Pune city, and a peaceful atmosphere. It is a favorite destination for sightseeing, photography, and spiritual visits."
    },
    {
      title: "Mulshi Dam",
      description: "Mulshi Dam is a scenic getaway near Pune surrounded by lush green hills, lakes, waterfalls, and peaceful landscapes. It is a popular destination for weekend trips, nature lovers, and photographers."
    },
    {
      title: "Bedse Caves",
      description: "Bedse Caves are ancient Buddhist rock-cut caves near Pune, known for their intricate carvings, peaceful surroundings, and historical significance. They are a popular destination for history enthusiasts and trekkers."
    }
  ],






"services": [
  {
    "name": "Kurla to Pune Taxi Service Rates",
    "description": "Get affordable Kurla to Pune Taxi Service Rates with fixed fares, clean AC cars, experienced drivers, doorstep pickup, transparent pricing, comfortable seating, and reliable outstation travel for business trips, family journeys, airport transfers, and daily travel."
  },
  {
    "name": "Kurla to Pune Taxi Service Number",
    "description": "Contact our Kurla to Pune Taxi Service Number for instant cab booking, 24x7 customer support, verified chauffeurs, multiple vehicle options including Sedan, Ertiga, Innova Crysta, and safe intercity transportation with quick confirmation."
  },
  {
    "name": "Kurla to Pune One Way Cab Service",
    "description": "Book Kurla to Pune One Way Cab Service with affordable fares, professional drivers, sanitized AC vehicles, on-time pickup, luggage assistance, and comfortable highway travel without return charges."
  },
  {
    "name": "Kurla to Pimpri Cab Service",
    "description": "Choose Kurla to Pimpri Cab Service for convenient intercity travel with experienced chauffeurs, comfortable vehicles, fixed pricing, doorstep pickup, and safe long-distance transportation."
  },
  {
    "name": "Kurla to Pune Station Cab Fare",
    "description": "Check Kurla to Pune Station Cab Fare with transparent pricing, no hidden charges, multiple cab categories, and affordable travel packages for railway station transfers."
  },
  {
    "name": "Kurla to Baner Cab Fare",
    "description": "Book Kurla to Baner Cab with fixed fare pricing, AC cars, trained drivers, smooth highway travel, and reliable pickup and drop service for business and personal travel."
  },
  {
    "name": "Kurla to Pune Ertiga Cab Fare",
    "description": "Reserve Kurla to Pune Ertiga Cab Fare for spacious family travel with comfortable seating, ample luggage space, professional chauffeurs, and affordable SUV pricing."
  },
  {
    "name": "Kurla Station to Pune Taxi Service",
    "description": "Travel from Kurla Station to Pune with reliable taxi service offering punctual pickup, clean AC vehicles, experienced drivers, fixed fares, and safe intercity transportation."
  },
  {
    "name": "Kurla Station to Pune Sedan Taxi Service",
    "description": "Choose Kurla Station to Pune Sedan Taxi Service for economical travel with comfortable sedans, professional chauffeurs, transparent pricing, and timely pickup."
  },
  {
    "name": "Kurla to Viman Nagar Taxi",
    "description": "Book Kurla to Viman Nagar Taxi with comfortable AC cars, experienced drivers, affordable fares, and convenient doorstep pickup and drop service."
  },
  {
    "name": "Kurla to Pune Round Trip Cab",
    "description": "Reserve Kurla to Pune Round Trip Cab with flexible return timing, fixed fares, chauffeur-driven vehicles, and comfortable travel for business, family, and weekend trips."
  },
  {
    "name": "Taxi Service in Kurla Mumbai",
    "description": "Our Taxi Service in Kurla Mumbai provides reliable local and outstation transportation with well-maintained vehicles, professional drivers, instant booking, and affordable fares."
  },
  {
    "name": "Best Cab Service in Kurla Mumbai",
    "description": "Choose the Best Cab Service in Kurla Mumbai for premium travel experience with Sedan, Ertiga, Innova Crysta, luxury vehicles, courteous chauffeurs, and 24x7 booking support."
  },
  {
    "name": "Innova Crysta on Rent in Kurla Mumbai",
    "description": "Hire Innova Crysta on Rent in Kurla Mumbai for family tours, corporate travel, airport transfers, and comfortable outstation journeys with spacious premium vehicles."
  },
  {
    "name": "Ertiga Hire in Kurla Mumbai",
    "description": "Book Ertiga Hire in Kurla Mumbai for affordable family travel with spacious seating, clean interiors, experienced drivers, and reliable intercity transportation."
  },
  {
    "name": "Kurla to Pune Cab",
    "description": "Book Kurla to Pune Cab with fixed pricing, AC vehicles, trained chauffeurs, doorstep pickup, safe highway travel, and comfortable transportation for business and leisure trips."
  },
  {
    "name": "Kurla to Pune Taxi",
    "description": "Reserve Kurla to Pune Taxi with affordable fares, professional drivers, sanitized vehicles, luggage assistance, and dependable door-to-door travel service."
  },
  {
    "name": "Kurla to Pune Taxi Service",
    "description": "Our Kurla to Pune Taxi Service offers reliable one-way and round-trip travel with premium vehicles, transparent pricing, experienced chauffeurs, and 24x7 booking support."
  },
  {
    "name": "Kurla to Pune Cab Service",
    "description": "Choose Kurla to Pune Cab Service for safe, comfortable, and affordable intercity travel with multiple vehicle options and professional drivers."
  },
  {
    "name": "Kurla to Pune One Way Cab",
    "description": "Book Kurla to Pune One Way Cab for direct travel without return fare, offering clean AC vehicles, punctual pickup, and smooth highway transportation."
  },
  {
    "name": "Kurla to Pune Taxi Booking",
    "description": "Complete Kurla to Pune Taxi Booking online with instant confirmation, fixed fares, secure reservations, and multiple vehicle choices."
  },
  {
    "name": "Kurla to Pune Drop Taxi",
    "description": "Reserve Kurla to Pune Drop Taxi for convenient one-way travel with professional chauffeurs, clean cars, affordable pricing, and reliable service."
  },
  {
    "name": "Kurla to Pune Online Cab Booking",
    "description": "Book Kurla to Pune Online Cab Booking with instant confirmation, secure payment options, transparent fares, and 24x7 customer assistance."
  },
  {
    "name": "Kurla to Pune Private Cab",
    "description": "Travel comfortably with Kurla to Pune Private Cab featuring exclusive chauffeur-driven vehicles, flexible timing, privacy, and premium travel experience."
  },
  {
    "name": "Kurla to Pune Outstation Cab",
    "description": "Choose Kurla to Pune Outstation Cab for long-distance travel with AC cars, experienced drivers, fixed pricing, and dependable intercity service."
  },
  {
    "name": "Kurla to Pune Cheap Cab",
    "description": "Book Kurla to Pune Cheap Cab with budget-friendly fares, comfortable vehicles, professional drivers, and reliable outstation transportation."
  },
  {
    "name": "Kurla to Pune AC Cab Service",
    "description": "Travel in comfort with Kurla to Pune AC Cab Service offering well-maintained air-conditioned vehicles, experienced chauffeurs, and smooth highway journeys."
  },
  {
    "name": "Kurla to Pune Innova Cab",
    "description": "Hire Kurla to Pune Innova Cab for spacious family travel, corporate trips, airport transfers, and comfortable long-distance transportation."
  },
  {
    "name": "Kurla East to Pune Cab",
    "description": "Book Kurla East to Pune Cab with doorstep pickup, affordable fares, clean AC vehicles, and experienced drivers for safe travel."
  },
  {
    "name": "Kurla West to Pune Cab",
    "description": "Choose Kurla West to Pune Cab for reliable one-way or round-trip travel with premium vehicles, professional chauffeurs, and transparent pricing."
  },
  {
    "name": "Kurla to Pune Round Trip Taxi",
    "description": "Reserve Kurla to Pune Round Trip Taxi with flexible return schedules, fixed fare packages, comfortable vehicles, and dependable chauffeur service."
  },
  {
    "name": "Kurla to Pune Cab Per Km Rate",
    "description": "Check Kurla to Pune Cab Per Km Rate with transparent pricing, affordable packages, and multiple vehicle options for every travel requirement."
  },
  {
    "name": "Kurla to Pune Sedan Taxi",
    "description": "Book Kurla to Pune Sedan Taxi for affordable and comfortable travel with clean AC sedans, trained drivers, and timely pickup service."
  },
  {
    "name": "Kurla to Pune Innova Crysta Cab",
    "description": "Choose Kurla to Pune Innova Crysta Cab for premium outstation travel with spacious seating, luxury comfort, professional chauffeurs, and smooth highway journeys."
  }
],

"tableData": [
  ["Kurla to Pune Taxi Service Rates", "Kurla to Pune Taxi Service Number"],
  ["Kurla to Pune One Way Cab Service", "Kurla to Pimpri Cab Service"],
  ["Kurla to Pune Station Cab Fare", "Kurla to Baner Cab Fare"],
  ["Kurla to Pune Ertiga Cab Fare", "Kurla Station to Pune Taxi Service"],
  ["Kurla Station to Pune Sedan Taxi Service", "Kurla to Viman Nagar Taxi"],
  ["Kurla to Pune Round Trip Cab", "Taxi Service in Kurla Mumbai"],
  ["Best Cab Service in Kurla Mumbai", "Innova Crysta on Rent in Kurla Mumbai"],
  ["Ertiga Hire in Kurla Mumbai", "Kurla to Pune Cab"],
  ["Kurla to Pune Taxi", "Kurla to Pune Taxi Service"],
  ["Kurla to Pune Cab Service", "Kurla to Pune One Way Cab"],
  ["Kurla to Pune Taxi Booking", "Kurla to Pune Drop Taxi"],
  ["Kurla to Pune Online Cab Booking", "Kurla to Pune Private Cab"],
  ["Kurla to Pune Outstation Cab", "Kurla to Pune Cheap Cab"],
  ["Kurla to Pune AC Cab Service", "Kurla to Pune Innova Cab"],
  ["Kurla East to Pune Cab", "Kurla West to Pune Cab"],
  ["Kurla to Pune Round Trip Taxi", "Kurla to Pune Cab Per Km Rate"],
  ["Kurla to Pune Sedan Taxi", "Kurla to Pune Innova Crysta Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Kurla to Pune Taxi Service",
    WhyChoosedescription: "Trustline Cab provides dependable Kurla to Pune taxi services with experienced drivers, comfortable vehicles, and hassle-free intercity travel."
  },
  {
    WhyChooseheading: "Convenient Pickup from Kurla",
    WhyChoosedescription: "Get doorstep pickup from Kurla East, Kurla West, Kurla Railway Station, hotels, offices, and residential areas with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Journey",
    WhyChoosedescription: "Our trained chauffeurs ensure a safe, comfortable, and timely journey with excellent knowledge of the Mumbai–Pune Expressway."
  },
  {
    WhyChooseheading: "Comfortable Fleet for Every Requirement",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your travel needs and passenger count."
  },
  {
    WhyChooseheading: "Transparent Taxi Fare",
    WhyChoosedescription: "Receive clear fare details before booking with competitive pricing and no hidden charges for your Kurla to Pune journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Taxi Options",
    WhyChoosedescription: "Book one-way taxis, return trips, or customized travel plans according to your preferred schedule and destination."
  },
  {
    WhyChooseheading: "Suitable for Business & Personal Travel",
    WhyChoosedescription: "Our Kurla to Pune taxi service is ideal for corporate meetings, airport transfers, family travel, medical visits, and leisure trips."
  },
  {
    WhyChooseheading: "24/7 Taxi Booking Support",
    WhyChoosedescription: "Book your Kurla to Pune taxi anytime with instant confirmation and dedicated customer support throughout your journey."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Kurla to Pune taxi service?",
    answer: "Yes, Trustline Cab offers reliable Kurla to Pune taxi services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way taxi from Kurla to Pune?",
    answer: "Yes, one-way taxi services are available with flexible pickup from Kurla and direct drop anywhere in Pune."
  },
  {
    question: "Do you provide pickup from Kurla East and Kurla West?",
    answer: "Yes, we provide doorstep pickup from Kurla East, Kurla West, Kurla Railway Station, and nearby Mumbai locations."
  },
  {
    question: "Which vehicles are available for Kurla to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable intercity travel."
  },
  {
    question: "Is Kurla to Pune taxi service available 24 hours?",
    answer: "Yes, our taxi services operate 24/7, allowing you to travel at your preferred time."
  },
  {
    question: "Can I reserve a return taxi from Pune to Kurla?",
    answer: "Yes, round-trip taxi services are available for passengers planning return travel between Pune and Kurla."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in the confirmed booking quotation."
  },
  {
    question: "Should I book my taxi in advance?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and pickup schedule."
  },
  {
    question: "Do you provide Kurla to Pune taxis for corporate travel?",
    answer: "Yes, our taxi services are suitable for business meetings, employee transportation, client visits, and regular corporate travel."
  },
  {
    question: "How can I book Kurla to Pune Taxi Service with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ritesh Mehta",
    feedback: "Trustline Travels provided an excellent Kurla to Pune taxi service with punctual pickup, a comfortable cab, and a courteous driver. The entire journey was smooth and enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sonali Patil",
    feedback: "The booking process was simple, the vehicle was clean, and the driver was highly professional. Our trip from Kurla to Pune was comfortable, safe, and completed on time.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kurla to Pune Taxi Service",
  "image": "https://www.trustlinetravels.com/assets/images/kurla-to-pune-taxi-service.webp",
  "description":
    "Book Kurla to Pune Taxi Service with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Kurla to Pune, Pimpri Chinchwad, Baner, Pune Railway Station, and all Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/kurla-to-pune-taxi-service"
  }
};






  return (
    <div>
<Helmet>
  <title>Kurla to Pune Taxi Service | One Way Cab | +91 8087080034</title>

  <meta
    name="description"
    content="Book Kurla to Pune Taxi Service with Trustline Travels for reliable one-way and round-trip taxi services. Travel from Kurla to Pune, Pimpri Chinchwad, Baner, Pune Railway Station, and nearby destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 at affordable fares."
  />

  <meta
    name="keywords"
    content="Kurla to pune taxi service rates, Kurla to pune taxi service number, kurla to pune one way cab service, kurla to pimpri cab service, kurla to pune station cab fare, kurla to baner cab fare, kurla to pune ertiga cab fare, kurla station to pune taxi service, Kurla to Pune Taxi Service, Kurla Pune Cab Booking, Kurla to Pune Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/114.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kurlatopunetaxiservice;